export default __webpack_public_path__ + "static/media/Trapezoid.e3b5f90d.svg";